<script>
    import { afterUpdate, onDestroy, onMount } from "svelte";

    import Circle from "../components/Circle.svelte";

    import { gameState, gameTick, pause, timeIsUp } from "../store";

    import { generateCircles } from "../gameHelpers";

    export let genre;
    export let headphoneImage;
    export let backgroundImage;

    let playArea = null;

    let score;
    let maxScore;

    let totalTime;
    let timeLeft;
    let progressBarValue;
    let circles = [];
    let regenerateLevel = true;

    gameState.subscribe((state) => {
        totalTime = state.totalTime;
        timeLeft = state.timeLeft;
        progressBarValue = state.progressBarValue;
        score = state.score;
        maxScore = state.maxScore;
        regenerateLevel = state.regenerateLevel;
    });

    let progressInterval = setInterval(() => {
        progressBarValue = (timeLeft * 100) / totalTime + 100;
        timeLeft--;

        gameTick({
            progressBarValue,
            timeLeft,
        });

        if (progressBarValue <= 0) {
            timeIsUp();
        }
    }, 1000);

    onDestroy(() => {
        clearInterval(progressInterval);
        document.documentElement.style = "";
        document.body.style.overflow = "";
    });

    onMount(() => {
        let vh = window.innerHeight * 0.01;

        document.documentElement.style.setProperty("--vh", `${vh}px`);

        window.addEventListener("resize", () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        });

        document.body.style.overflow = "hidden";

        dataLayer.push({ event: "game_start" });
    });

    afterUpdate(() => {
        if (regenerateLevel) {
            circles = generateCircles(10, playArea);
            gameState.update((state) => ({
                ...state,
                regenerateLevel: false,
            }));
        }
    });

    let bgImageTemplate = `background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url("${backgroundImage}");`;
</script>

<style>
    .container {
        height: 100vh;
        /* Use vh as a fallback for browsers that do not support Custom Properties */
        height: calc(var(--vh, 1vh) * 100);
        margin: 0 auto;
        max-width: 100%;
        user-select: none;
    }

    .pause {
        z-index: 999;
    }
</style>

<div class="container" bind:this={playArea} style={bgImageTemplate}>
    {#each circles as circleProps}
        {#key circleProps.key}
            <Circle
                isBad={circleProps.isBad}
                duration={circleProps.duration}
                delay={circleProps.delay}
                left={circleProps.left}
                top={circleProps.top} />
        {/key}
    {/each}
    <div class="div-block-6" style={`width: ${progressBarValue}%`} />
    <div class="head">
        <div class="pause">
            <div class="sound-icon w-embed" on:click={pause}>
                <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"><path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z"
                        clip-rule="evenodd" /></svg>
            </div>
            <div class="sound-icon-on w-embed">
                <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"><path
                        fill-rule="evenodd"
                        d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z"
                        clip-rule="evenodd" /></svg>
            </div>
        </div>
    </div>
    <div class="score-wrap">
        <div class="photo-wrap">
            <img src={headphoneImage} class="img_game" alt="" />
        </div>
        <div>
            <h3 class="heading2">{genre}</h3>
            <h3 class="heading2 score">{score}/{maxScore}</h3>
        </div>
    </div>
</div>
